import { Icon } from '@tf/ui';
import type React from 'react';
import { Link } from 'react-router-dom';

export const RefLink: React.FC<{ to: string }> = ({ to }) => {
	return (
		<Link to={to} style={{ verticalAlign: 'middle', marginLeft: '2px' }}>
			<Icon.IconExternalLink size={14} />
		</Link>
	);
};
